module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_7042.6d797f28.png";